import * as React from 'react';
import * as style from './Sellers.css';

import { INewbuildingSellerSchema } from '../../../../repositories/newbuilding-card/entities/agents/NewbuildingSellerSchema';
import { INewbuildingBuilderSchema } from '../../../../repositories/newbuilding-card/entities/builder/NewbuildingBuilderSchema';
import { SectionTitle } from '../../../SectionTitle';
import { Seller } from '../Seller';

export interface ISellersProps {
  newbuildingId: number;
  sellers?: INewbuildingSellerSchema[] | null;
  trackActionOpenContactsCall(builder: INewbuildingBuilderSchema | INewbuildingSellerSchema): void;
  isPlural?: boolean | null;
}

export const Sellers: React.FC<ISellersProps> = props => {
  const { sellers, trackActionOpenContactsCall, isPlural, newbuildingId } = props;

  if (!sellers || sellers.length < 1) {
    return null;
  }

  const title = `Представители ${isPlural ? 'застройщиков' : 'застройщика'}`;

  return (
    <div className={style['sellers']} data-mark={'Sellers'}>
      <SectionTitle>{title}</SectionTitle>

      <div className={style['sellers-list']}>
        {sellers.map(seller => (
          <Seller
            newbuildingId={newbuildingId}
            key={seller.realtyUserId}
            eventTracker={trackActionOpenContactsCall}
            seller={seller}
          />
        ))}
      </div>
    </div>
  );
};
